import {
  type DialogActionsProps,
  type DialogContentProps,
  type DialogContentTextProps,
  type DialogProps,
  type DialogTitleProps,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogTitle as MuiDialogTitle,
} from '@mui/material';
import convert from 'color-convert';
import { Box, IconButton, useTheme } from 'hephaestus/web';
import { Close } from 'hephaestus/webIcons';
import { forwardRef } from 'react';

interface OvDialogTitleProps extends DialogTitleProps {
  onClose?: () => void;
  testIds?: { dialogCloseButton?: string };
}

export const Dialog = (props: DialogProps) => {
  const theme = useTheme();
  const rgb = convert.hex.rgb(theme.color.background || '#000000');

  return (
    <MuiDialog
      sx={{
        '.MuiDialog-paper': {
          borderRadius: theme.borderRadius.xxl,
        },
        '.MuiBackdrop-root': {
          background: `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.85)`,
        },
        ...props?.sx,
      }}
      {...props}
    />
  );
};

export const DialogTitle = (props: OvDialogTitleProps) => {
  const theme = useTheme();

  if (props.onClose) {
    return (
      <MuiDialogTitle
        sx={{ borderBottom: `1px solid ${theme.color.outlineVariant}` }}
        {...props}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {props.children}
          <IconButton
            aria-label='close'
            onClick={props.onClose}
            data-testid={props?.testIds?.dialogCloseButton}
          >
            <Close fontSize='inherit' />
          </IconButton>
        </Box>
      </MuiDialogTitle>
    );
  }

  return (
    <MuiDialogTitle
      sx={{ borderBottom: `1px solid ${theme.color.outlineVariant}` }}
      {...props}
    />
  );
};

export const DialogFooter = (props: DialogActionsProps) => {
  const theme = useTheme();

  return (
    <MuiDialogActions
      sx={{ borderTop: `1px solid ${theme.color.outlineVariant}`, p: 1.5 }}
      {...props}
    />
  );
};
export const DialogContent = (props: DialogContentProps) => (
  <MuiDialogContent {...props} sx={{ ...props.sx, pt: '16px !important' }} />
);

export const RefDialogContent = forwardRef((props: DialogContentProps, ref) => (
  <MuiDialogContent
    {...props}
    sx={{ ...props.sx, pt: '16px !important' }}
    ref={ref}
  />
));

export const DialogContentText = (props: DialogContentTextProps) => (
  <MuiDialogContentText {...props} />
);
